var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "input_delivery" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_content wrapper" },
        [
          _c("dd-menu", { ref: "menuRef" }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("dd-flow", {
                attrs: {
                  pageKey: _vm.pageKey,
                  pageList: _vm.orderForm.pageList
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input_list" }, [
                _c("ul", [
                  _c("li", { staticClass: "input_text" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.postcd)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.form.postcd,
                          expression: "form.postcd",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "list_box",
                      attrs: {
                        type: "text",
                        disabled: _vm.form.isNewInput === false,
                        oninput: "if(value.length>7)value=value.slice(0,7)",
                        placeholder: "0001111"
                      },
                      domProps: { value: _vm.form.postcd },
                      on: {
                        keypress: _vm.validateNumber,
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "postcd",
                              $event.target.value.trim()
                            )
                          },
                          function($event) {
                            _vm.form.postcd = _vm.inputRestNumber($event)
                          }
                        ],
                        blur: [
                          _vm.addressCompletion,
                          function($event) {
                            _vm.$forceUpdate()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.postcd
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.postcd))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text2" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.state)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input_field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.state,
                            expression: "form.state",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "list_box",
                        attrs: {
                          type: "text",
                          disabled: _vm.form.isNewInput === false,
                          maxlength: "32",
                          placeholder: "都道府県"
                        },
                        domProps: { value: _vm.form.state },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "state",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "space" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.city,
                            expression: "form.city",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "list_box",
                        attrs: {
                          type: "text",
                          disabled: _vm.form.isNewInput === false,
                          maxlength: "32",
                          placeholder: "市区町村"
                        },
                        domProps: { value: _vm.form.city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "city",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.state
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.state))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.street)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.form.street,
                          expression: "form.street",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "list_box",
                      attrs: {
                        type: "text",
                        maxlength: "32",
                        placeholder: "町名"
                      },
                      domProps: { value: _vm.form.street },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "street",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.street
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.street))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text2" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.userName)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input_field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.userLastName,
                            expression: "form.userLastName",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "32",
                          placeholder: "家具"
                        },
                        domProps: { value: _vm.form.userLastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "userLastName",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "space" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.userFirstName,
                            expression: "form.userFirstName",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "32",
                          placeholder: "太郎"
                        },
                        domProps: { value: _vm.form.userFirstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "userFirstName",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.userName
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.userName))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text2" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.userNameKana)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input_field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.userLastNameKana,
                            expression: "form.userLastNameKana",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "32",
                          placeholder: "カグ"
                        },
                        domProps: { value: _vm.form.userLastNameKana },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "userLastNameKana",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "space" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.userFirstNameKana,
                            expression: "form.userFirstNameKana",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "32",
                          placeholder: "タロウ"
                        },
                        domProps: { value: _vm.form.userFirstNameKana },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "userFirstNameKana",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.userNameKana
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.userNameKana))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.tel)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.form.tel,
                          expression: "form.tel",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "list_box",
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>11)value=value.slice(0,11)",
                        placeholder: "0123456789",
                        maxlength: "11"
                      },
                      domProps: { value: _vm.form.tel },
                      on: {
                        keypress: _vm.validateNumber,
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "tel",
                              $event.target.value.trim()
                            )
                          },
                          function($event) {
                            _vm.form.tel = _vm.inputRestNumber($event)
                          }
                        ],
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.tel
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.tel))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.label.disiredDate)),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("label", { staticClass: "list_key" }, [
                        _vm._v(_vm._s(_vm.label.desiredDate1st))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "list_day" },
                      [
                        _c("dd-calendar", {
                          attrs: {
                            schedule: _vm.schedule,
                            value: _vm.form.desiredDate1st
                          },
                          on: { selectedDate: _vm.selectedDate1 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.errors.desiredDate1st
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.desiredDate1st))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("label", { staticClass: "list_key" }, [
                        _vm._v(_vm._s(_vm.label.desiredDate2nd))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "list_day" },
                      [
                        _c("dd-calendar", {
                          attrs: {
                            schedule: _vm.schedule,
                            value: _vm.form.desiredDate2nd
                          },
                          on: { selectedDate: _vm.selectedDate2 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.errors.desiredDate2nd
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.desiredDate2nd))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("label", { staticClass: "list_key" }, [
                        _vm._v(_vm._s(_vm.label.desiredDate3rd))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "list_day" },
                      [
                        _c("dd-calendar", {
                          attrs: {
                            schedule: _vm.schedule,
                            value: _vm.form.desiredDate3rd
                          },
                          on: { selectedDate: _vm.selectedDate3 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.errors.desiredDate3rd
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.desiredDate3rd))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.label.homeType)),
                        _c("span", { staticClass: "important small_text" }, [
                          _vm._v("必須")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.form.homeType,
                            expression: "form.homeType",
                            modifiers: { number: true }
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "homeType1",
                          name: "homeType"
                        },
                        domProps: {
                          value: 1,
                          checked: _vm._q(_vm.form.homeType, _vm._n(1))
                        },
                        on: {
                          change: function($event) {
                            _vm.$set(_vm.form, "homeType", _vm._n(1))
                          }
                        }
                      }),
                      _c("label", { attrs: { for: "homeType1" } }, [
                        _vm._v("戸建")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.form.homeType,
                            expression: "form.homeType",
                            modifiers: { number: true }
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "homeType2",
                          name: "homeType"
                        },
                        domProps: {
                          value: 2,
                          checked: _vm._q(_vm.form.homeType, _vm._n(2))
                        },
                        on: {
                          change: function($event) {
                            _vm.$set(_vm.form, "homeType", _vm._n(2))
                          }
                        }
                      }),
                      _c("label", { attrs: { for: "homeType2" } }, [
                        _vm._v("マンション・アパート")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.homeType
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.homeType))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.label.parkingSpace)),
                      _c("span", { staticClass: "important small_text" }, [
                        _vm._v("必須")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.parkingSpace,
                            expression: "form.parkingSpace"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "parkingSpace1",
                          name: "parkingSpace"
                        },
                        domProps: {
                          value: false,
                          checked: _vm._q(_vm.form.parkingSpace, false)
                        },
                        on: {
                          change: function($event) {
                            _vm.$set(_vm.form, "parkingSpace", false)
                          }
                        }
                      }),
                      _c("label", { attrs: { for: "parkingSpace1" } }, [
                        _vm._v("なし")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.parkingSpace,
                            expression: "form.parkingSpace"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "parkingSpace2",
                          name: "parkingSpace"
                        },
                        domProps: {
                          value: true,
                          checked: _vm._q(_vm.form.parkingSpace, true)
                        },
                        on: {
                          change: function($event) {
                            _vm.$set(_vm.form, "parkingSpace", true)
                          }
                        }
                      }),
                      _c("label", { attrs: { for: "parkingSpace2" } }, [
                        _vm._v("あり")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.errors.parkingSpace
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.parkingSpace))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "input_text" }, [
                    _c("label", { staticClass: "list_key" }, [
                      _vm._v(_vm._s(_vm.label.message))
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.message,
                          expression: "form.message"
                        }
                      ],
                      staticClass: "list_box",
                      attrs: {
                        cols: "100",
                        rows: "5",
                        maxlength: "256",
                        placeholder: "組立設置時の連絡事項をご記入ください。"
                      },
                      domProps: { value: _vm.form.message },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "message", $event.target.value)
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("section", { attrs: { id: "construct_confirm" } }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "input_list" }, [
                  _c(
                    "div",
                    { staticClass: "rule_parts" },
                    [
                      _c("dd-struct-rule-detial", {
                        on: { onScrollEnd: _vm.onScrollEnd }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("section", { attrs: { id: "construct_check" } }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "check_box caution_confim" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmDelivery,
                        expression: "confirmDelivery"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "confirmDelivery",
                      disabled: !_vm.isScrollEnd
                    },
                    domProps: {
                      checked: Array.isArray(_vm.confirmDelivery)
                        ? _vm._i(_vm.confirmDelivery, null) > -1
                        : _vm.confirmDelivery
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.confirmDelivery,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.confirmDelivery = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.confirmDelivery = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.confirmDelivery = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "confirmDelivery" } }, [
                    _vm._v("\n            注意事項を確認しました。\n          ")
                  ])
                ])
              ]),
              _vm._v(" "),
              Object.keys(_vm.errors).length > 0
                ? _c("div", { staticClass: "error_text" }, [
                    _vm._v(
                      "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "control_btn_area" }, [
                _c(
                  "div",
                  { staticClass: "detail_btn2", on: { click: _vm.reEdit } },
                  [_vm._v("もどる")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      detail_btn: true,
                      disabled: _vm.confirmDelivery === false
                    },
                    on: {
                      click: function($event) {
                        _vm.confirm()
                      }
                    }
                  },
                  [_vm._v("ご注文内容確認")]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("組立設置情報入力画面")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("組立・設置サービスにおける注意事項・免責事項")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "caution_text" }, [
        _vm._v(
          "組立・設置サービスにおける注意事項・面積事項を確認してください。"
        ),
        _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f03d711e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f03d711e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcConstructInput.vue
// module id = null
// module chunks = 